import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";

export default class CmsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  close = () => {
    this.setState({ showModal: false });
  };

  open = () => {
    this.setState({ showModal: true });
  };

  render() {
    return (
      <div>
        <Button
          variant="success"
          className="float-right"
          style={{ fontSize: "15px", backgroundColor: "#28a745" }}
          size="lg"
          onClick={this.open}
        >
          MORE INFO
        </Button>

        <Modal
          show={this.state.showModal}
          onHide={this.close}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          scrollable="true"
          centered
        >
          <Modal.Body>
            <h4 style={{ color: "#49B544", fontWeight: "bold" }}>
              Clinic Management System (CMS)
            </h4>
            <br />
            <h5 style={{ fontWeight: "bold" }}>Clinic Operations Fortified </h5>
            <div style={{ color: "#919191" }}>
              <p>
                A flexible, integrated, and user-friendly solution to support
                free-standing and multi-specialty clinics to efficiently and
                effectively serve patients while competently managing their
                administrative tasks.
              </p>
              <br />
              <p>
                <ul>
                  <li>Built-in Patient Orchestration</li>
                  <li>Real-time Analytics</li>
                  <li>Performance Management, governance and compliance</li>
                </ul>
              </p>
            </div>

            <div style={{ textAlign: "center" }} md={12}>
              <Button className="btn-success" onClick={this.close}>
                Close
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
